<template>
    <div>
        <!-- <v-container v-intersect="getMoreMessages"></v-container> -->
        <div
        v-for="(message_date, key) in structuredMessages"
        :key="message_date.sid"
        class="mb-4"
        id="messages_container"
        >   
            <div style="clear:both;"></div>
            <v-container class="sticky my-4" style="width:100%;">
                <v-row align="center">
                    <v-divider></v-divider> 
                    <v-chip small>{{key || 'New Messages'}}</v-chip> 
                    <v-divider></v-divider>
                </v-row>
            </v-container>
            <div v-for="message in message_date" :key="message.sid" :id="message.sid">
                <!-- Time -->
                <div>
                    <div class="text-caption grey--text" style="clear:both;" :style="message.direction == 'inbound' ? 'float:left;' : 'float:right;'">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" style="cursor:pointer;">{{messageTime(message)}}</span>
                            </template>
                            <span>
                                <span v-if="message.direction == 'inbound'">{{app.phoneNumberFormat(message.from)}} <v-icon small>mdi-arrow-right</v-icon> {{app.phoneNumberFormat(message.to)}}</span>
                                <span v-else>{{app.phoneNumberFormat(message.to)}} <v-icon small>mdi-arrow-left</v-icon> {{app.phoneNumberFormat(message.from)}}</span>
                            </span>
                        </v-tooltip>
                    </div>
                </div>
                <!-- <v-container v-if="showMessageDateDivider(message)" class="sticky">
                    <v-row align="center">
                        <v-divider></v-divider> {{messageDate(message)}} <v-divider></v-divider>
                    </v-row>
                </v-container> -->

                <!-- SMS Body -->
                <div v-if="message.type == 'sms' && message.body.length > 0 && message.status != 'queued'"
                    class="px-4 py-2 mb-4 white--text text-left"
                    :class="message.direction == 'inbound' ? 'secondary' : 'primary'"
                    style="display:inline-block; clear:both; border-radius:15px; max-width:80%;"
                    :style="message.direction == 'inbound' ? 'float:left;' : 'float:right;'"
                    v-html="formatBody(message.body)"
                ></div>

                <!-- Message queued -->
                <div class="my-4" v-if="message.status == 'queued'" style="clear:both;">
                    <v-progress-circular x-small indeterminate  class="float-right"></v-progress-circular>
                </div>

                <!-- Images/Files  -->
                <div style="clear:both;">
                    <span v-for="x in [0,1,2,3,4,5,6,7,8,9]" :key="`image-${message.sid}-${x}`">
                        <span v-if="message.type == 'sms' && message[`mediaurl${x}`]">
                            <v-img
                                v-if="message[`mediaurl${x}`].indexOf('image/') > 0 || message[`mediaurl${x}`].indexOf('contentType') == -1" 
                                :lazy-src="app.placeholder_img" 
                                :src="message[`mediaurl${x}`]" 
                                @load="scrollToBottom()" 
                                max-width="70%" 
                                class="rounded-lg mb-2 show-image white" 
                                @click="showImage(message[`mediaurl${x}`])"
                                :style="message.direction == 'inbound' ? 'float:left;' : 'float:right;'"
                            >
                                <!-- Sending image progress indicator -->
                                <v-overlay :opacity="0.8" :absolute="true" :value="message.status == 'sent' || message.SmsStatus == 'sent'" class="text-center">
                                        Sending image...
                                        <v-progress-linear indeterminate color="success"></v-progress-linear>
                                </v-overlay>

                                <!-- Failed Image Overlay -->
                                <v-overlay :absolute="true" :value="message.status == 'failed' || message.SmsStatus == 'failed'" class="text-center error--text">
                                    <v-chip color="error" class="px-4">
                                        <v-icon left>mdi-alert-circle-outline</v-icon>
                                        Failed to send
                                    </v-chip>
                                </v-overlay>
                            </v-img>
                            <div v-if="message[`mediaurl${x}`].indexOf('audio/') > 0"
                                class="px-4 py-2 mb-4 white--text text-right"
                                style="display:inline-block; clear:both; border-radius:15px; max-width:80%; width:"
                                :class="message.direction == 'inbound' ? 'secondary float-left' : 'primary float-right'"
                            >
                                <audio-player 
                                    label="Audio" 
                                    :url="message[`mediaurl${x}`]" playerid="audio-player"
                                    :expanded="true"> 
                                </audio-player>
                            </div>

                            <div v-if="message[`mediaurl${x}`].indexOf('application/') > 0"
                                class="px-4 py-2 mb-4 white--text text-right"
                                style="display:inline-block; clear:both; border-radius:15px; max-width:80%; width:"
                                :class="message.direction == 'inbound' ? 'secondary float-left' : 'primary float-right'"
                            >
                                <v-btn :href="message[`mediaurl${x}`]" text x-small target="_blank">
                                    <v-icon>mdi-file</v-icon> File
                                </v-btn>
                            </div>
                        </span>
                    </span>
                </div>
            

                <!-- Phone Call -->
                <div v-if="message.type == 'voice'"
                    class="px-4 py-2 mb-4 white--text "
                    :class="message.direction == 'inbound' ? 'text-right secondary' : 'text-left primary'"
                    style="display:inline-block; clear:both; border-radius:15px; max-width:80%; width:"
                    :style="message.direction == 'inbound' ? 'float:left;' : 'float:right;'"
                >
                    <audio-player 
                        v-if="message.recording && message.recording.length > 0" 
                        :label="message.direction == 'inbound' ? 'Incoming Call' : 'Outgoing Call'" 
                        :url="message.recording" playerid="audio-player"
                        :expanded="true"> 
                    </audio-player>
                </div>
            </div>
        </div>

        

        <!-- BM: VIEW IMAGE DIALOG -->
        <v-dialog v-model="show_image_dialog" overlay-opacity="1" align="center" justify="center">
            <v-layout style="height:100%;">
                <v-img v-if="show_image_url" :src="show_image_url" contain @click="show_image_dialog = false; show_image_url = null;" class="show-image white"></v-img>
            </v-layout>
        </v-dialog>
        <!-- <div id="temp_loading_placeholder" style="height:90vh;"></div> -->
    </div>
</template>
<script>
import { useAppStore } from '../stores/app'
import Pusher from 'pusher-js'
import AudioPlayer from './AudioPlayer.vue'

export default {
    name: 'Messages',
    props: ['messages', 'phone_number'],
    components: {
        AudioPlayer
    },
    data: () => ({
        app: null,
        show_image_dialog: false,
        show_image_url: null,
        loading: false,
        last_message_date: null,
        structured_messages: {},
        // message_dates: []
    }),
    created: function() {
        this.app = useAppStore()
    },
    mounted: function() {
        // this.loadCommunications()
        this.subscribe()
        // this.getMessageDates()
    },
    computed: {
        structuredMessages: function() {
            if(!this.messages)
                return
            let structured_messages = {}
            let g = this
            Object.keys(this.messages).forEach(key => {
                let message_date = this.messageDate(g.messages[key])
                if(!structured_messages[message_date])
                    structured_messages[message_date] = []
                structured_messages[message_date].push(g.messages[key])
            })
            // this.structured_messages = structured_messages
            // return this.messages
            return structured_messages
        }
    },
    methods: {
        // getMessageDates: function() {
        //     let msg_dates = []
        //     this.messages.forEach(msg => {
        //         msg_dates.push(this.messageDate(msg))
        //     })
        //     let set = new Set(msg_dates)
        //     this.message_dates = [...set]
        // },
        getMoreMessages: function(message) {
            this.$emit('getMoreMessages')
        },
        messageDateTime: function(message) {
            if(message.date)
                return moment.utc(message.date).local().format('MMM Do YYYY, h:mm A')
                // return moment.utc(message.date).local().format('MMMM Do YYYY, h:mm A')
            return ""
        },
        messageTime: function(message) {
            if(message.date)
                return moment.utc(message.date).local().format('h:mm A')
                // return moment.utc(message.date).local().format('MMMM Do YYYY, h:mm A')
            return ""
        },
        messageDate: function(message) {
            // console.log("get messageDate", message)
            if(!message.date)
                return ""
            return moment.utc(message.date).local().format('MMM Do YYYY')
        },
        showMessageDateDivider: function(message) {
            if(!message.date)
                return false

            let message_date = moment.utc(message.date).local().format('MMM Do YYYY')

            console.log(message.date)
            console.log(message_date)
            console.log(this.last_message_date)
            console.log(message_date == this.last_message_date)
            if(message_date != this.last_message_date) {
                this.last_message_date = message_date
                console.log("show the divider")
                console.log('=========================')
                return true
            }
            console.log("DO NOT show the divider")
            console.log('=========================')
            return false
        },
        formatBody: function(body) {
            if(!body)
                return
                
            let matches = body.match(/(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g);
            if(matches) {
                matches.forEach(url => {
                    body = body.replace(url, `<a href="${url}" class="white--text" target="_blank">${url}</a>`)
                })
            }

            // Line breaks are replaced with [NL] when saving the activity in the db
            // We need to replace them with line breaks of some sort

            //double line break
            body = body.replace(/\n\n/g, '<div class="mb-2"></div>')
            body = body.replace(/\[NL\]\[NL\]/g, '<div class="mb-2"></div>')

            //single line breaks
            body = body.replace(/\n/g, '<br />')
            body = body.replace(/\[NL\]/g, '<br />')

            return body
        },
        scrollToBottom: function() {
            setTimeout(function() {
                var messagesDiv = document.getElementById("messages");
                messagesDiv.scrollTop = messagesDiv.scrollHeight;
            }, 100)
            // var messagesDiv = document.getElementById("messages");
            //     messagesDiv.scrollTop = messagesDiv.scrollHeight;
        },
        showImage: function(url) {
            this.show_image_dialog = true
            this.show_image_url = url
        },
        subscribe: function () {
            let pusher = new Pusher('48bff4f1fa51477735f7', { cluster: 'us2' })
            pusher.subscribe('dialernow1')    //TODO: user_id
            pusher.bind('call_status', data => {
                this.app.updateCallStatus(data)
            })
            pusher.bind('activity_added', data => {
                
                //only add to current window if the phone number matches, 
                //otherwise add an indicator somewhere for new message received

                var existing = false

                if(this.messages[data.sid]) {
                    this.messages[data.sid] = { ...this.messages[data.sid], ...data }
                    console.log("update message", this.messages[data.sid])
                } else {
                    this.phone_number.forEach(number => {
                        if(data.from.indexOf(number) > -1)
                            this.$set(this.messages, data.sid, data)
                    })
                    
                    // this.messages[data.sid] = data
                    console.log("add new message", this.messages[data.sid])

                    //play notification
                    if(data.direction == 'inbound') {
                        this.app.playNotification()
                        this.app.getUnreadMessages()
                    }
                }
                this.scrollToBottom()
            })
        },
    },
}
</script>


<style scoped>
.show-image {
    cursor:pointer;
    max-height: 96vh;
}
.sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
}
</style>

